import { useJobApplicationStore } from '../jobApplication/useJobApplicationStore';
import { useDaySequenceStore } from '../daySequence/useDaySequenceStore';

export const unassignWorkerFromJobEffect = async (
  jobId: string,
  unassignedUserId: string | undefined,
): Promise<void> => {
  if (!unassignedUserId) {
    return;
  }

  try {
    const jobApplicationStore = useJobApplicationStore.getState();

    const deletedApplication = jobApplicationStore.jobApplications.find(
      (application) =>
        application.userId === unassignedUserId && application.jobId === jobId,
    );

    jobApplicationStore.removeJobApplication(deletedApplication?.id ?? '');

    await useDaySequenceStore.getState().refresh(jobId);
  } catch (error) {
    console.error('Error in unassignWorkerFromJobEffect: ', error);
  }
};
